module.exports = __webpack_public_path__ + "img/home_img_jxjj.b457794b.png";